import Vue from 'vue';

const setUser = (email, name) => {
  // Vue.ma.setUsername(email);
  // Vue.ma.setUserProperties({ name });
};

const resetUser = () => {
  // Vue.ma.reset();
};

const viewedFloorplan = (floorplan) => {
  // Vue.ma.trackEvent({
  //   action: 'ViewedFloorplan',
  //   properties: {
  //     floorplanName: floorplan.name,
  //     floorplanInterior: floorplan.interior,
  //     floorplanBeds: floorplan.beds,
  //     floorplanDens: floorplan.dens,
  //     floorplanBaths: floorplan.baths
  //   }
  // });
};

const favouritedFloorplan = (floorplan) => {
  // Vue.ma.trackEvent({
  //   action: 'FavouritedFloorplan',
  //   properties: {
  //     floorplanName: floorplan.name,
  //     floorplanInterior: floorplan.interior,
  //     floorplanBeds: floorplan.beds,
  //     floorplanDens: floorplan.dens,
  //     floorplanBaths: floorplan.baths
  //   }
  // });
};

export default {
  setUser,
  resetUser,
  viewedFloorplan,
  favouritedFloorplan
};



// WEBPACK FOOTER //
// ./src/analytics/tracking.js